import React, { useState } from "react";
import UpTastingLogo from "../../../assets/images/hcb_logo_light.png";
import styled from "@emotion/styled";
import StartEngine from "./Start/StartEngine";
import ScreenEngine from "./Screens/ScreenEngine";
import EndEngine from "./End/EndEngine";

const SurveyComponent = ({ config, cookie}) => {

  const Wrapper = {
    height: "100vh",
    display: "flex",
    position: "relative",
    background: "white",
    justifyContent: "center",
    flexDirection: "column"
  };

  const Text = styled.div`
    margin: 4vh auto;
    color: black;
    font-size: 3vh;
  `;

  return (
    <div style={Wrapper}>

      {!config?.survey ? (
        <StartEngine config={config} />
      ) : config?.currentScreen < config?.survey?.screens?.length ? (
        <ScreenEngine config={config} cookie={cookie} />
      ) : (
        <EndEngine config={config}/>
      )}

    </div>
  );
};

export default SurveyComponent;
